import { useCanceledTimeout } from './useCanceledTimeout'

export const useDebounced = (callback: () => void | Promise<void>, delay: number) => {
  const timer = useCanceledTimeout();

  const promisedCall = () => {
    return new Promise<void>(() => {
      timer.setTimeout(async () => {
        try {
          await callback(); 
        } catch (e) {
          console.error(e)
        }
      }, delay);
    })
  }

  const call = () => {
    return promisedCall();
  }

  return call;
}
